import { render, staticRenderFns } from "./NewCopyModal.vue?vue&type=template&id=4501e536&scoped=true&"
import script from "./NewCopyModal.vue?vue&type=script&lang=js&"
export * from "./NewCopyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4501e536",
  null
  
)

export default component.exports